//src/pages/SorteioQRCodePage.jsx

import React, { useEffect, useMemo, useState } from "react";
import axios from "../axiosConfig";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Copy } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import "./SorteioQRCodePage.css";

function SorteioQRCodePage() {
  const { id } = useParams();
  const [sorteio, setSorteio] = useState(null);
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    axios
      .get(`/admin/sorteios-leads/id/${id}`)
      .then(({ data }) => setSorteio(data.sorteio))
      .catch(() => setMensagem("Erro ao carregar sorteio."));
  }, [id]);

  const linkPublico = useMemo(() => {
    if (!sorteio?.slug) return "";
    return `https://www.tikpontos.com.br/sorteios/${sorteio.slug}`;
  }, [sorteio]);

  const copiarLink = async () => {
    try {
      await navigator.clipboard.writeText(linkPublico);
      setMensagem("Link copiado.");
    } catch {
      setMensagem("Não foi possível copiar o link.");
    }
  };

  return (
    <div className="sorteioQRCode-page">
      <Link to="/admin/sorteios-leads" className="sorteioQRCode-back">
        <ArrowLeft size={16} />
        Voltar
      </Link>

      <div className="sorteioQRCode-card">
        <div className="sorteioQRCode-logoBox">
          <img src="/logo2.png" alt="Tikpag" />
        </div>

        <span className="sorteioQRCode-kicker">Aponte a câmera do celular</span>

        <h1>{sorteio?.titulo || "Sorteio Tikpag"}</h1>

        <p>Escaneie o QR Code para se cadastrar e participar do sorteio.</p>

        {linkPublico && (
          <div className="sorteioQRCode-box">
            <QRCodeCanvas
              value={linkPublico}
              size={360}
              includeMargin
              level="H"
            />
          </div>
        )}

        <code>{linkPublico}</code>

        <button type="button" onClick={copiarLink}>
          <Copy size={17} />
          Copiar link
        </button>

        {mensagem && <div className="sorteioQRCode-message">{mensagem}</div>}
      </div>
    </div>
  );
}

export default SorteioQRCodePage;